interface Props {
  status: string
}

const StatusCell: React.FC<Props> = ({ status }) => {
  const findStatus = (_status: string) => {
    switch (_status.toLowerCase()) {
      case 'drafting':
        return 'รอดำเนินการ'
      case 'loaded':
        return 'สแกนสำเร็จ'
      case 'hold':
        return 'หยุดพัก'
      case 'cancel':
        return 'ยกเลิกโครงการ'
      case 'completed':
        return 'เสร็จสิ้น'
      default:
        return _status
    }
  }

  const findColor = (_status: string) => {
    switch (_status.toLowerCase()) {
      case 'drafting':
        return 'badge-primary'
      case 'in progress':
        return 'badge-primary'
      case 'hold':
        return 'badge-warning'
      case 'cancel':
        return 'badge-danger'
      case 'loaded':
        return 'badge-success'
      default:
        return ''
    }
  }

  return (
    <>
      {status && status.toLowerCase() !== '' ? (
        <span className={`badge ${findColor(status)}`}>{findStatus(status)}</span>
      ) : (
        '-'
      )}
    </>
  )
}

export default StatusCell
